import {
  Component,
  DestroyRef,
  effect,
  inject,
  OnInit,
  PLATFORM_ID,
  signal,
} from '@angular/core';
import { assets } from '../../core/constants/assets.const';
import { aiService } from '../../services/ai.service';
import { CoordinatesService } from '../../services/coordinates.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { filter } from 'rxjs';
import { EncryptionService } from '../../services/encryption.service';
import { immediateVehicleService } from '../../services/immediateVehicle.service';
import { isPlatformBrowser } from '@angular/common';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'logibids-map-widgets',
  imports: [],
  templateUrl: './map-widgets.component.html',
  styleUrl: './map-widgets.component.scss',
})
export class MapWidgetsComponent implements OnInit {
  assetsConst = assets;
  traffic: boolean = false;
  satellite: boolean = false;
  location: boolean = false;
  isDriverHome: boolean = false;
  isTracking: boolean = false;
  sos = signal<boolean>(false);
  private router = inject(Router);
  showMapWidgets: boolean = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  user: any;
  showWidgetPickUp = signal<boolean>(false);
  private platformId = inject(PLATFORM_ID);
  private route = inject(ActivatedRoute);
  readonly isBrowser = isPlatformBrowser(this.platformId);
  accessToken = signal<string | null>(null);
  private authService = inject(AuthService);
  shareType: number | null = null;
  supportPhone = signal<string | null>(null);
  constructor(
    private _aiService: aiService,
    private _CoordinatesService: CoordinatesService,
    private destory: DestroyRef,
    private _encryption: EncryptionService,
    private immediateVehicleService: immediateVehicleService
  ) {
    this.user = this._encryption.decryptLocalStorage('profile');
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntilDestroyed(this.destory)
      )
      .subscribe((event: NavigationEnd) => {
        this.isDriverHome = event.urlAfterRedirects.startsWith('/services');
        this.isTracking = event.urlAfterRedirects.startsWith('/tracking');
        this.showMapWidgets = event.urlAfterRedirects.startsWith(
          '/transport/wheretogo'
        );
        if (this.showMapWidgets === false) {
          this.satellite = true;
          this.traffic = true;
          this.setTraffic();
          this.setSatellite();
        }
      });

    effect(() => {
      const data = this.immediateVehicleService.getImmediateData();
      if (data() !== null) {
        this.showWidgetPickUp.set(data());
      }
    });

    effect(() => {
      if (!this.isBrowser) return;
      const token = localStorage['accessToken'];
      if (this.authService.profileDetails()?.token) {
        this.accessToken.set(this.authService.profileDetails()?.token);
      } else {
        this.accessToken.set(token || undefined);
      }
    });

    effect(() => {
      const supportPhone = this.immediateVehicleService.getSupportPhone();
      if (supportPhone() !== null) {
        this.supportPhone.set(supportPhone());
      }
    });
  }

  ngOnInit(): void {
    this.route.queryParamMap.subscribe(params => {
      this.shareType = Number(params.get('shareType'));
    });
  }

  openAI(): void {
    this._aiService.setData(true);
  }

  btn_sos(value: boolean): void {
    const sosValue = !value;
    this.sos.set(sosValue);
  }

  getFillColor(): string {
    return this.traffic ? '#FF000C' : '#A5A8AA';
  }

  getFillColorSatellite(): string {
    return this.satellite ? '#FF000C' : '#A5A8AA';
  }

  getFillColorLocation(): string {
    return this.location ? '#FF000C' : '#A5A8AA';
  }

  setLocation(): void {
    this._CoordinatesService.getCurrentLocation();
    this.location = !this.location;
  }

  setTraffic(): void {
    this.traffic = !this.traffic;
    this._CoordinatesService.setTraffic(this.traffic);
  }

  setSatellite(): void {
    this.satellite = !this.satellite;
    this._CoordinatesService.setSatellite(this.satellite);
  }
}
